export function fetchDataError(state = false, action) {
	switch (action.type) {
	case 'FETCH_ERROR':
		return action.hasErrored;
	default:
		return state;
	}
}

export function fetchDataLoading(state = true, action) {
	switch (action.type) {
	case 'FETCH_LOADING':
		return action.isLoading;
	default:
		return state;
	}
}

const initialState = {
	data: {},
	geoJSON: {},
	selectedDisease: null
};

export function data(state = initialState, action) {
	switch (action.type) {
	case 'FETCH_SUCCESS':
		return action.json;
	case 'SET_OUTBREAK_FILTERS':
		return {
			...state,
			numActiveFilters: action.numActiveFilters,
			outbreakFilters: action.outbreakFilters.map(filter => (filter.name === action.name ? action.payload : filter))
		};
	case 'SET_FILTERED_OUTBREAKS':
		return {
			...state,
			filteredOutbreaks: action.filteredOutbreaks
		};
	default:
		return state;
	}
}
